import { Header, Input, FileInput, Button } from 'components/common';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

const VerifyProperty = () => {
  const CreatePropertySchema = Yup.object().shape({
    deedNo: Yup.string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long!')
      .required('Required'),
    deedyear: Yup.string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long!')
      .required('Required'),
  });
  const handleVerifyPptSubmit = (values: any) => {
    console.log('values', values);
  };

  return (
    <>
      <div className="bg-black pb-16">
        <Header />
        <div className="container mx-auto px-4 md:px-8 xl:px-16 mt-32">
          <div className="text-center">
            <p className="text-white text-4xl font-medium">Verify ownership</p>
          </div>

          <Formik
            initialValues={{
              deedNo: '',
              deedYear: '',
            }}
            validationSchema={CreatePropertySchema}
            onSubmit={(values) => {
              handleVerifyPptSubmit(values);
            }}
          >
            <Form className="mt-16">
              <div className="grid lg:grid-cols-2 sm:grid-cols-1 gap-14">
                <Input
                  label="Deed No."
                  placeholder="Title deed no"
                  className="bg-transparent border border-primary-2 py-2 px-3 mt-4 focus:outline-none text-white"
                  type="text"
                  name="deedNo"
                />

                <Input
                  label="Deed Year"
                  placeholder="Deed issue year"
                  className="bg-transparent border border-primary-2 py-2 px-3 mt-4 focus:outline-none text-white"
                  type="text"
                  name="deedNo"
                />
              </div>

              <div className="flex justify-center mt-16">
                <FileInput
                  label="Title Deed  / Land certifcate"
                  headText="Supported file type : PNG, JPEG, PDF. Max size : 10 MB  "
                  name="deedOfAssignment"
                />
              </div>

              <div className="grid lg:grid-cols-2 sm:grid-cols-1 gap-14 mt-16">
                <FileInput
                  label="Valid ID ( Passport, National ID Card, Driver’s Licsense)"
                  headText="Supported file type : PNG, JPEG, PDF. Max size : 10 MB"
                  name="validId"
                />
                <FileInput
                  label="Receipt / Proof of purchase"
                  headText="Supported file type : PNG, JPEG, PDF. Max size : 10 MB"
                  name="receipt"
                />
              </div>

              <div className="flex justify-center mt-16">
                <Button className="px-12 py-3" type="submit" variant="primary">
                  Verify
                </Button>
              </div>
            </Form>
          </Formik>
        </div>
      </div>
    </>
  );
};

export default VerifyProperty;
